const {AdminTableRow} = require("../../../../../../../dumb/TableRow");
const {
  DisplayAmountFCAdmin,
  DisplayDateAdmin,
  DisplayAmountAdmin
} = require("../../../../../../../dumb/DisplayData");
const React = require("react");
const upperFirst = require("mn-utils/upperFirst");
const formatNum = require("../../../../../../../../utils/formatNum");

module.exports = ({data, index}) => {
  const {
    created_at_date,
    released_at,
    fraction = 0,
    payment_gateway = '',
    accum_amount = 0,
    accum_asset,
    target_amount = 0,
    target_asset,
    status = ''
  } = data;

  return (
    <AdminTableRow className="f12" onClick={false} index={index}>
      <div className="wmin185 fx1 bold">
        <DisplayDateAdmin
          date={created_at_date}
        />
      </div>
      <div className="wmin185 fx1 bold">
        <DisplayDateAdmin
          date={released_at}
        />
      </div>
      <div className="wmin185 fx1">
        {upperFirst(payment_gateway)}
      </div>
      <div className="wmin185 fx1">
        {formatNum(fraction * 100, 4)}%
      </div>
      <div className="wmin185 fx1">
        {accum_amount && target_amount
          ? (
            <DisplayAmountFCAdmin
              fiat={{amount: accum_amount, symbol: accum_asset}}
              crypto={{amount: target_amount, symbol: target_asset}}
            />
          )
          : accum_amount
            ? (
              <DisplayAmountAdmin
                amount={accum_amount}
                symbol={accum_asset}
                type="fiat"
              />
            ) : (
              <DisplayAmountAdmin
                amount={target_amount}
                symbol={target_asset}
                type="crypto"
              />
            )
        }
      </div>
      <div className="wmin185 fx1 bold">
        {upperFirst(status)}
      </div>
    </AdminTableRow>
  );
};
